import { http } from '@/lib/api';
import type { SessionUser } from './session.js';

/**
 * Who the caller is, according to KainOS.
 *
 * Called once right after Cognito hands over a token: the token says which
 * person this is, and this says which organization they work in and what they
 * may do there. No tenant header is sent, so the server picks the caller's
 * default membership.
 */
export function getMe(): Promise<SessionUser> {
  return http.get<SessionUser>('/me');
}
